import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledButtonTooltipCopy = ({
  upgradeProduct,
  conflictingTrial
}) => {
  if (conflictingTrial) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.trialActivationButton.tooltip.disabledButtonConflict",
      options: {
        conflictingUpgradeProduct: I18n.text(`upgrades.products.${conflictingTrial}`)
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "upgrades.trialActivationButton.tooltip.disabledButton",
    options: {
      upgradeProduct: I18n.text(`upgrades.products.${upgradeProduct}`)
    }
  });
};
const TrialActivationButtonWithTooltip = ({
  use,
  upgradeProduct,
  onClick,
  isTrialed,
  showActivationModalContainer,
  isLoading,
  trialI18nKey,
  propsToPass,
  children,
  conflictingTrial
}) => {
  const resultIcon = showActivationModalContainer ? 'success' : null;
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !isTrialed && !conflictingTrial,
    placement: "bottom",
    title: /*#__PURE__*/_jsx(DisabledButtonTooltipCopy, {
      upgradeProduct: upgradeProduct,
      conflictingTrial: conflictingTrial
    }),
    children: propsToPass.use && propsToPass.use.includes('link') ? /*#__PURE__*/_jsx(UIButton, Object.assign({}, propsToPass, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-button",
      disabled: isTrialed || conflictingTrial,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    })) : /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, propsToPass, {
      use: use,
      onClick: onClick,
      "data-selenium": "trial-button",
      "data-test-id": "trial-loading-button",
      loading: showActivationModalContainer || isLoading,
      disabled: isTrialed || conflictingTrial,
      resultIcon: resultIcon,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: trialI18nKey
      })
    }))
  });
};
export default TrialActivationButtonWithTooltip;